import { Link } from 'react-router-dom';

/**
 * Fußzeile der angemeldeten und der offenen Seiten außerhalb der Partie.
 *
 * Gemeinsam genutzt von Anmeldung und Partienübersicht: Die Pflichtangaben
 * müssen von jeder Seite aus erreichbar sein, nicht nur von der Anmeldemaske –
 * wer angemeldet ist, käme sonst nur über die Adresszeile ans Impressum.
 *
 * Die Fläche ist in beiden Farbschemata dunkel, weil sie in beiden Fällen auf
 * dem Titelbild liegt.
 */
export function SiteFooter() {
  return (
    <footer className="border-t border-white/10 bg-black/30 backdrop-blur">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-3 px-4 py-3 sm:flex-row sm:justify-between sm:px-7">
        <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-white/50">
          <Link to="/legal/impressum" className="transition-colors hover:text-white">
            Impressum
          </Link>
          <Link to="/legal/datenschutz" className="transition-colors hover:text-white">
            Datenschutz
          </Link>
          <Link to="/legal/nutzungsbedingungen" className="transition-colors hover:text-white">
            Nutzungsbedingungen
          </Link>
          <span className="text-white/35">Kostenlos spielbar</span>
        </nav>

        {/*
          Einladung in die Gemeinschaft.
          Der Verweis steht bewusst neben den Pflichtangaben und nicht im
          Anmeldebereich: Wer noch kein Konto hat, soll erst spielen können
          und dann mitreden – nicht umgekehrt.

          Das Zeichen liegt als Pfad im Markup und wird nicht von Discord
          geladen. Die Datenschutzerklärung sagt zu, dass beim Aufruf der
          Seite keine Verbindung zu Dritten entsteht; ein eingebundenes
          Fremdbild wäre genau das. Erst der Klick führt hinaus.
        */}
        <a
          href="https://discord.gg/QjjNeM2b3e"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center gap-2 rounded-lg border border-white/10 bg-white/[0.06] px-3 py-1.5 text-xs text-white/70 transition-colors hover:border-accent-400/50 hover:bg-white/[0.11] hover:text-white"
        >
          <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="currentColor" className="shrink-0">
            <path d="M20.317 4.369a19.79 19.79 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128c.126-.094.252-.192.372-.291a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.009c.12.099.246.198.373.292a.077.077 0 0 1-.006.127 12.3 12.3 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.056c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.028zM8.02 15.331c-1.183 0-2.157-1.086-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.211 0 2.176 1.096 2.157 2.42 0 1.332-.955 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.086-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.211 0 2.176 1.096 2.157 2.42 0 1.332-.946 2.418-2.157 2.418z" />
          </svg>
          <span className="font-mono text-2xs uppercase tracking-[0.16em]">Discord</span>
          <span aria-hidden="true" className="text-accent-400 transition-transform group-hover:translate-x-0.5">
            →
          </span>
        </a>

        {/* Partnerhinweis: das Spiel entsteht gemeinsam mit einem echten Hoster. */}
        <a
          href="https://pawhost.de"
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="group flex items-center gap-2.5 rounded-lg border border-white/10 bg-white/[0.06] px-3 py-1.5 transition-colors hover:border-accent-400/50 hover:bg-white/[0.11]"
        >
          <span className="font-mono text-2xs uppercase tracking-[0.16em] text-white/40">In Zusammenarbeit mit</span>
          {/*
            Das Logo liegt lokal unter public/, nicht als Verweis auf
            pawhost.de: Die Datenschutzerklärung sagt zu, dass beim Aufruf
            der Seite keine Verbindung zu Dritten entsteht. Ein
            eingebundenes Fremdbild wäre genau das.
          */}
          <img src="/pawhost-logo.svg" alt="PawHost" width={89} height={26} className="h-[26px] w-auto" />
          <span aria-hidden="true" className="text-accent-400 transition-transform group-hover:translate-x-0.5">
            →
          </span>
        </a>
      </div>
    </footer>
  );
}
